import React, { useEffect, useState } from "react";
import FileExplorer from "../components/FileExplorer";
import CharacterBackground from "../components/CharacterBackground";
import { useNavigate } from "react-router-dom";
import { useGlobalState } from "../context/GlobalStateContext";
import { resetAudioDatabase } from "../services/audios";

import "./AudioManagementPage.css";

function AudioManagementPage() {
  const { sessionInfo, sendSocketMessage } = useGlobalState();
  const [isResetting, setIsResetting] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (sessionInfo.user === null) {
      sessionInfo.fetchUser();
    } else {
      if (sessionInfo.user.isMaster === false) {
        navigate("/characters/list");
      }
    }
  }, [sessionInfo, navigate]);

  useEffect(() => {
    // Controlla se l'utente è loggato
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login");
      return;
    }
  }, [navigate]);

  const handleResetDatabase = async () => {
    const confirmed = window.confirm(
      "Sei sicuro di voler resettare il database audio? Tutti i titoli personalizzati verranno persi e verranno ricreati dai file fisici.",
    );

    if (!confirmed) return;

    setIsResetting(true);
    try {
      const result = await resetAudioDatabase();
      console.log("Database reset result:", result);
      alert(
        `Database resettato con successo!\n\n` +
          `Record cancellati: ${result.deletedRecords}\n` +
          `Record aggiunti: ${result.addedRecords}\n` +
          `Gruppi trovati: ${result.groupsFound}`,
      );

      // Refresh the audio list via WebSocket
      sendSocketMessage("REFRESH_AUDIOLIST", null);
    } catch (error) {
      console.error("Error resetting database:", error);
      alert("Errore nel resettare il database. Controlla i log.");
    } finally {
      setIsResetting(false);
    }
  };

  return (
    <div className="audiomanagment-page page-wrapper">
      <CharacterBackground />
      <div className="audiomanagment-page_content page-content">
        <div className="audiomanagment-header">
          <h1>Gestione Audio</h1>
          <p>Seleziona e riproduci gli effetti sonori per la tua sessione</p>
          {sessionInfo.user?.username === "gennaro" && (
            <button
              onClick={handleResetDatabase}
              disabled={isResetting}
              style={{
                marginTop: "15px",
                padding: "10px 20px",
                background: isResetting ? "#6b4a4a" : "#8b0000",
                color: "#ffffff",
                border: "2px solid #a52a2a",
                borderRadius: "6px",
                cursor: isResetting ? "wait" : "pointer",
                fontSize: "14px",
                fontWeight: "600",
                opacity: isResetting ? 0.6 : 1,
                transition: "all 0.3s ease",
                boxShadow: "0 0 10px rgba(139, 0, 0, 0.5)",
              }}
              onMouseEnter={(e) => {
                if (!isResetting) {
                  e.target.style.background = "#a52a2a";
                  e.target.style.boxShadow = "0 0 20px rgba(165, 42, 42, 0.8)";
                }
              }}
              onMouseLeave={(e) => {
                if (!isResetting) {
                  e.target.style.background = "#8b0000";
                  e.target.style.boxShadow = "0 0 10px rgba(139, 0, 0, 0.5)";
                }
              }}
            >
              {isResetting ? "Resettando..." : "🔄 Reset Database Audio"}
            </button>
          )}
        </div>
        <FileExplorer />
      </div>
    </div>
  );
}

export default AudioManagementPage;
